<div class="ui-account-password-change">
    <h3 class="ui-account-password-change-title ui-title" mat-dialog-title>Modificar mi contraseña</h3>
  
    <div class="ui-account-password-change-content" mat-dialog-content>
        <form [formGroup]="formData">
            <div class="ui-form">                        
                <div class="ui-form-row">
                    <mat-form-field class="ui-input">
                        <mat-label>Contraseña actual</mat-label>
                        <input matInput  [attr.type]="(inputDataVisibility.passwordCurrent ? 'text' : 'password')" formControlName="passwordCurrent">
                        <mat-icon class="ui-icon" matSuffix (click)="inputDataVisibility.passwordCurrent = !inputDataVisibility.passwordCurrent">{{(inputDataVisibility.passwordCurrent ? 'visibility_off' : 'visibility_on')}}</mat-icon>
                        <mat-error *ngIf="formHasError('passwordCurrent', 'validate')">{{formHasError('passwordCurrent', 'message')}}</mat-error>
                    </mat-form-field>
                </div> 
                
                <div class="ui-divider">Nueva contraseña</div>

                <div class="ui-form-row">
                    <mat-form-field class="ui-input">
                        <mat-label>Nueva contraseña</mat-label>
                        <input matInput  [attr.type]="(inputDataVisibility.passwordNew ? 'text' : 'password')" formControlName="passwordNew">
                        <mat-icon class="ui-icon" matSuffix (click)="inputDataVisibility.passwordNew = !inputDataVisibility.passwordNew">{{(inputDataVisibility.passwordNew ? 'visibility_off' : 'visibility_on')}}</mat-icon>
                        <mat-error *ngIf="formHasError('passwordNew', 'validate')">{{formHasError('passwordNew', 'message')}}</mat-error>
                    </mat-form-field>                    
                </div>
                
                <div class="ui-form-row">
                    <mat-form-field class="ui-input">
                        <mat-label>Repetir contraseña</mat-label>
                        <input matInput  [attr.type]="(inputDataVisibility.passwordRepeat ? 'text' : 'password')" formControlName="passwordRepeat">
                        <mat-icon class="ui-icon" matSuffix (click)="inputDataVisibility.passwordRepeat = !inputDataVisibility.passwordRepeat">{{(inputDataVisibility.passwordRepeat ? 'visibility_off' : 'visibility_on')}}</mat-icon>
                        <mat-error *ngIf="formHasError('passwordRepeat', 'validate')">{{formHasError('passwordRepeat', 'message')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    
    <div class="ui-account-password-change-actions" mat-dialog-actions>
      <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
      <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Modificar</button>
    </div>
</div>